import { ref } from 'vue';
import { defineStore } from 'pinia';
import { applyPatch } from 'fast-json-patch';

export const useEventRuntimeEngineServiceInfoStore = defineStore('eventRuntimeEngineServiceInfoStore', () => {
    const eventRuntimeEngineServiceInfos = ref({});

    function addEventRuntimeEngineServiceInfo(eventRuntimeEngineServiceInfoModel) {
        eventRuntimeEngineServiceInfos.value[eventRuntimeEngineServiceInfoModel.id] = eventRuntimeEngineServiceInfoModel;
    }

    function updateEventRuntimeEngineServiceInfo(id, eventRuntimeEngineServiceInfoModel) {
        eventRuntimeEngineServiceInfos.value[id] = eventRuntimeEngineServiceInfoModel;
    }

    function removeEventRuntimeEngineServiceInfo(id) {
        delete eventRuntimeEngineServiceInfos.value[id];
    }

    function applyJsonPatch(id, jsonPatch) {
        applyPatch(eventRuntimeEngineServiceInfos.value[id], jsonPatch, false, true);
    }

    return {
        eventRuntimeEngineServiceInfos,
        addEventRuntimeEngineServiceInfo,
        updateEventRuntimeEngineServiceInfo,
        removeEventRuntimeEngineServiceInfo,
        applyJsonPatch
    }
})